import { OptionTile } from "@manifesthhqinc/ui-library";
import { TitleLarge } from "../../../components/font";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Container from "../../../layout/container";
import ScrollableContainer from "../../../layout/scrollable-container";
import { OptionTileContainer } from "../../henry-questionniare/screens/styles";
import { UseExploreIRAOptionsType } from "../useExploreIRAOptions";
import { DIGITAL, PERSON, RARELY_NEED_HELP } from "../../../class/iraQuestionnaire";
import HeadingContainer from "../../../layout/heading-container";

const ExploreIRAOptionQuestionThree = (props: UseExploreIRAOptionsType) => {
  const { iraQuestionnaireData, updateHelpFeature } = props;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="henry-questionnaire-form-3">
        <Container>
          <HeadingContainer paneVariant="optionForm" withProgressBar>
            <TitleLarge>What kind of help do you prefer if you need it?</TitleLarge>
          </HeadingContainer>
          <OptionTileContainer>
            <OptionTile
              variant="clickthrough"
              appearance="secondary"
              onClick={() => updateHelpFeature(DIGITAL)}
              isSelected={iraQuestionnaireData.supportModel === DIGITAL}
              name="chat"
            >
              Chat or email is fine
            </OptionTile>
            <OptionTile
              variant="clickthrough"
              appearance="secondary"
              onClick={() => updateHelpFeature(PERSON)}
              isSelected={iraQuestionnaireData.supportModel === PERSON}
              name="person"
            >
              I’d want to speak to a person
            </OptionTile>
            <OptionTile
              variant="clickthrough"
              appearance="secondary"
              onClick={() => updateHelpFeature(RARELY_NEED_HELP)}
              isSelected={iraQuestionnaireData.supportModel === RARELY_NEED_HELP}
              name="noHelp"
            >
              I rarely need help
            </OptionTile>
          </OptionTileContainer>
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};

export default ExploreIRAOptionQuestionThree;
